<template>
    <div>
        <json-excel
            class   = "btn btn-default"
            :name    = "$t('common.dummy_email_credentials')+'.csv'"
            :title  = "$t('common.dummy_email_credentials')"
            :fields = "json_fields"
            :escapeCsv = "true"
            type    = "csv"
            :before-generate = "beforeGenerate"
            :before-finish = "beforeFinish"
            :fetch  = "doExport">
                <chip class="export-credential" v-loading.fullscreen.lock="exportLoading">
                    {{ $t('common.export_credentials') }}
                </chip>
        </json-excel>
    </div>
  </template>
  
  <script>
    import showNoReportDataWarning from '@/components/common/mixins/noReportData'
    import { isSessionExpireError } from '@/utils/sessionExpireErr'
    import Chip from '@/components/common/Chip'
    import JsonExcel from '@/components/lib/JsonExcel'
    import { mapGetters, mapActions, mapState } from 'vuex'
    import {
    pathOr, length, join, prop, compose, concat, __
    } from 'ramda'
    export default {
      mixins: [ showNoReportDataWarning ],
      components: {
        Chip,
        JsonExcel
      },
      data() {
        return {
          json_fields: {
              'id': 'id',
              'Email Dummy': 'email',
              'first name': 'first_name',
              'last name': 'last_name',
              'password': 'password',
          },
          exportLoading: false,
        }
      },
      destroyed () {
        this.$store.dispatch('students/resetdummyEmailCredentials')
      },
      methods: {
        ...mapActions('students',[
          "getAllDummyEmailCredentials",
        ]),
        async doExport() {
          if(!length(this.dummyEmailCredentials)) {
            try {
              await this.getAllDummyEmailCredentials(this.currentOrganizationId)
              .catch((err) => {
                if(!isSessionExpireError(err))
                  this.showNoReportDataWarning()
              })
              return this.dummyEmailCredentials;
            } catch(error) {
                return error
            }
          }
          return this.dummyEmailCredentials;
        },
        beforeGenerate(){
          return this.exportLoading = true;
        },
        beforeFinish(){
          return this.exportLoading = false;
        }
      },
      computed: {
        ...mapGetters('organization', [
      'currentOrganizationId', 
      ]),
        ...mapState('students', [
          'dummyEmailCredentials'
        ]),
      }
    }
  </script>
  
  <style lang="scss" scoped>
  .export-credential {
    margin: 0 10px;
    padding: 11px 11px;
    position: relative;
    bottom: 22px;
  }

  </style>
  